import { Component, OnDestroy, OnInit } from "@angular/core";

import {
  ViewStateService,
  ViewState,
} from "./shared/services/view-state.service";
import { delay, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

@Component({
  selector: "practitioner-portal",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit, OnDestroy {
  isLoggedIn: boolean;
  isMobileMenuOpen: boolean;
  isLoading: boolean;
  isAssessment = false;
  isBadge = false;
  onDestroy$ = new Subject();

  constructor(private viewState: ViewStateService) {}

  ngOnInit() {
    this.viewState.state$
      .asObservable()
      .pipe(delay(1), takeUntil(this.onDestroy$))
      .subscribe((state) => this.handleViewStateChanges(state));
  }

  private handleViewStateChanges(state: ViewState): void {
    this.isLoggedIn = state.isUserLoggedIn;
    this.isMobileMenuOpen = state.isMobileMenuOpen;
    this.isLoading = state.isLoading;
    this.isAssessment = state.isAssessment;
    this.isBadge = state.isBadge;

    if (this.isMobileMenuOpen)
      {document.querySelector("body").classList.add("primary-nav-open");}
    else {document.querySelector("body").classList.remove("primary-nav-open");}
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
